import { FC } from 'react';
import moment from 'moment';
import { SignatureSectionProps } from './harmReports.type';

export const SignatureSection: FC<SignatureSectionProps> = (props) => {
  return (
    <div className="flex flex-col flex-1">
      <img
        src={props.signature}
        alt={props.altText}
        className="mb-2 h-[56px] w-[136px]"
      />
      <span className="font-medium text-xs">{`${props.firstName} ${props.lastName}`}</span>
      <span className="text-gray-600 text-xs">
        {moment(props.date).format('DD/MM/YYYY, hh:mm A')}
      </span>
    </div>
  );
};
